import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form } from "react-bootstrap";
import { capitalizeFirstLetter } from '../Shared/Helpers';
import { isEmpty } from "lodash";
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepEight = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (storedData) {
            setFormData(storedData?.nextOfKin);
        } else {
            console.log("storedData is empty");
        }
    }, []);

    const validateForm = (formData) => {
        const errors = {
            fullName: isEmpty(formData?.fullName) && 'Full name is required',
            address: isEmpty(formData?.address) && 'Address is required',
            contactNo: isEmpty(formData?.contactNo) && 'Contact number is required',
            relationship: isEmpty(formData?.relationship) && 'Relationship is required',
        };
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);
            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HRInduction/SubmitNextOfKin?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                    body: JSON.stringify(formData),
                });
                if (response.status === 200) {
                    handleNext({ nextOfKin: formData });
                } else {
                    showErrorAlert(`Please fill out all required fields`);
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            showErrorAlert(`Please fill out all required fields`);
        }
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    return (
        <Row>
            {alert}
            <Col sm={12} md={12}>
                <h2 >8. Next of Kin</h2>
                <span style={{ marginTop: '-15px' }}>Please fill out all required fields</span>
            </Col>
            <Col sm={12} md={12}>
                <span><h5><strong><u>Next of kin details:</u></strong></h5></span>
            </Col>

            <Col sm={12} className="my-1">
                <h5 className="">Full Name:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.fullName}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                fullName: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.fullName ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.fullName && <Form.Text className="text-danger"> <span className="star">*</span> {errors.fullName} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={12} className="my-1">
                <h5 className="">Address:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="email"
                        value={formData?.address}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                address: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.address ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.address && <Form.Text className="text-danger"> <span className="star">*</span> {errors.address} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={12} className="my-1">
                <h5 className="">Contact number:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.contactNo}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                contactNo: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.contactNo ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.contactNo && <Form.Text className="text-danger"> <span className="star">*</span> {errors.contactNo} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={12} className="my-1">
                <h5 className="">Relationship:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.relationship}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                relationship: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.relationship ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.relationship && <Form.Text className="text-danger"> <span className="star">*</span> {errors.relationship} </Form.Text>}
                </Form.Group>
            </Col>
            <Col sm={12} md={12}>
                <span><h5>The details that you provide will be used in the event of emergencies. Should your circumstances change, and you no longer wish the person listed to be your next of kin, it is your responsibility to notify us immediately, so that our records can be updated.</h5></span>
            </Col>
            <Col sm={12} className="d-flex justify-content-between mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
            </Col>
        </Row>


    );
};

export default StepEight;

